import React from "react";
import styled from "styled-components";
import Input from "../../../components/Input";

const Row = styled.div`
  display: flex;
  gap: 16px;
  @media only screen and (max-width: 599px) {
    flex-direction: column;
  }
`;

export const MAX_NAME_LENGTH = 50;

/**
 * @param {{
 *  required?: boolean,
 *  value: {firstName: string, lastName: string},
 *  onChange: (value: {firstName: string, lastName: string}) => void,
 *  showError?: boolean,
 * }} props
 */
const AuthorNameFields = ({ required, value, onChange, showError }) => {
  const firstName = value?.firstName ?? "";
  const lastName = value?.lastName ?? "";

  const isFirstNameEmpty = required && showError && firstName.trim() === "";
  const isLastNameEmpty = required && showError && lastName.trim() === "";
  const isFirstNameOverLimit = firstName.length > MAX_NAME_LENGTH;
  const isLastNameOverLimit = lastName.length > MAX_NAME_LENGTH;

  return (
    <Row>
      <Input
        label="First name"
        value={firstName}
        onValueChange={(e) => onChange({ ...value, firstName: e.target.value })}
        errorCondition={isFirstNameEmpty || (showError && isFirstNameOverLimit)}
        maxLength={MAX_NAME_LENGTH}
        hintText={`${firstName.length}/${MAX_NAME_LENGTH} characters`}
        hintError={isFirstNameOverLimit}
      />
      <Input
        label="Last name"
        value={lastName}
        onValueChange={(e) => onChange({ ...value, lastName: e.target.value })}
        errorCondition={isLastNameEmpty || (showError && isLastNameOverLimit)}
        maxLength={MAX_NAME_LENGTH}
        hintText={`${lastName.length}/${MAX_NAME_LENGTH} characters`}
        hintError={isLastNameOverLimit}
      />
    </Row>
  );
};

export default AuthorNameFields;
